import { render, staticRenderFns } from "./discussion.vue?vue&type=template&id=61105a9b"
import script from "./discussion.vue?vue&type=script&lang=js"
export * from "./discussion.vue?vue&type=script&lang=js"
import style0 from "./discussion.vue?vue&type=style&index=0&id=61105a9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports